import { ProductPrice } from './products';

export type PriceType = 'surplus' | 'promotion';

export interface SurplusEntry {
  id: string;
  typeOfPrice: PriceType | null;
  promotionPrice: string | null;
  surplusPrice: string | null;
  shouldTransitionToSurplus: boolean;
  surplusStartDate: string | null;
  surplusEndDate: string | null;
  promotionStartDate: string | null;
  promotionEndDate: string | null;
  reasonForListing: string | null;
  bestBefore: string | null;
  useBy: string | null;
  reservedQuantity: string | null;
  dateCreated: string | null;
  productPrice: ProductPrice[] | null;
}

/**
 * Translation function to get the active price of a product.
 */
export function getActivePrice(
  surplusEntry: SurplusEntry | undefined | null,
  normalPrice: string | number | null | undefined
) {
  if (surplusEntry?.typeOfPrice === 'promotion') {
    return Number(surplusEntry.promotionPrice) || 0;
  }
  if (surplusEntry?.typeOfPrice === 'surplus') {
    return Number(surplusEntry.surplusPrice) || 0;
  }
  return Number(normalPrice) || 0;
}
